var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 431,
    height: 272,
    viewBox: "0 0 431 272",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M426.4 144.5A239.8 239.8 0 0 1 340.2 236.1a238.9 238.9 0 0 1-249.3 0A239.8 239.8 0 0 1 4.6 144.5L0.1 136l4.5-8.5a238.8 238.8 0 0 1 421.8 0L430.9 136ZM215.5 40.9a95.2 95.2 0 0 0-27.1 3.9 47.6 47.6 0 1 1-63.5 62.2A95.2 95.2 0 1 0 215.5 40.9Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyes);
export default __webpack_public_path__ + "static/media/eyes.4ca8a5224daa73a95f33aae45777879f.svg";
export { ForwardRef as ReactComponent };